<template>
  <div>
    <div class="filter" :class="className">
      <a-input-search allowClear v-model="selected.keyword" :placeholder="$t('personal.resource.searchPlaceholder')" @change="onSearch">
        <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
        <img class="clear" v-if="selected.keyword" slot="suffix" @click="selected.keyword = undefined, onSearch()" :src="require('@/assets/icons/icon_gb.png')" />
        <a-button class="search-btn" slot="enterButton">
          {{ $t('personal.resource.search') }}
        </a-button>
      </a-input-search>
      <a-select v-model="selected.interactionType" @change="onChange">
        <a-select-option :value="1">
          {{ $t('personal.resource.collection') }}
        </a-select-option>
        <a-select-option :value="2">
          {{ $t('personal.resource.like') }}
        </a-select-option>
      </a-select>
    </div>
    <div v-if="type !== 4" class="filter between">
      <div class="resourceType">
        <div class="label">{{ $t('personal.resource.resourceTypeLabel') }} </div>
        <div class="list" v-for="item in resourceTypeList" :key="item.value">
          <span :class="selected.resType === item.value ? 'selected':''" @click="typeChange(item.value)">{{ item.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { resTypeMap } from '@/api/lesson'

export default {
  props: {
    className: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      type: 1,
      selected: {
        resType: '',
        isAuth: false,
        keyword: undefined,
        interactionType: 1
      },
      resourceTypeList: []
    }
  },
  mounted() {
    this.getResTypeMap()
  },
  methods: {
    handleTypeChange(key) {
      this.type = key
      this.selected = {
        resType: '',
        isAuth: false,
        keyword: undefined,
        showResType: '',
        interactionType: 1
      }
      this.$emit('handleChange', this.selected)
    },
    onChange() {
      this.$emit('handleChange', this.selected)
    },
    onSearch() {
      this.selected.resType = ''
      this.$emit('handleChange', this.selected)
    },
    typeChange(id) {
      this.selected.resType = id
      this.$emit('handleChange', this.selected)
    },
    getResTypeMap() {
      this.resourceTypeList = [
        {
          label: this.$t('personal.resource.all'),
          value: '',
          checked: true
        },
        {
          label: this.$t('personal.resource.resourceType.model'),
          value: 'model',
          checked: false
        },
        {
          label: this.$t('personal.resource.resourceType.software'),
          value: 'software',
          checked: false
        },
        {
          label: this.$t('personal.resource.resourceType.text'),
          value: 'text',
          checked: false
        },
        {
          label: this.$t('personal.resource.resourceType.image'),
          value: 'image',
          checked: false
        },
        {
          label: this.$t('personal.resource.resourceType.video'),
          value: 'video',
          checked: false
        },
        {
          label: this.$t('personal.resource.resourceType.audio'),
          value: 'audio',
          checked: false
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.filter{
  display: flex;
  align-items: flex-end;
  height: 0px;
  /deep/.ant-input-group-wrapper{
    width: 237px;
    height: 35px;
    position: relative;
    .ant-input-prefix{
      // right: auto;
      left: 16px;
      img{
        width: 16px;
      }
    }
    .ant-input-suffix {
      right: 69px;
      .anticon.anticon-close-circle.ant-input-clear-icon{
        display: none;
      }
      .clear{
        width: 14px;
        height: 14px;
        cursor: pointer;
      }
    }
    .ant-input-search{
      width: 100%;
      height: 35px;
      .ant-input{
        height: 35px;
        color: #000;
        padding-left: 46px;
        border-radius: 20px;
        box-shadow: none;
        border: 1px solid #D8DCE0;
        &:focus{
          border-color: #ffb829;
          box-shadow: 0 0 0 2px rgba(255, 160, 0, 0.2);
        }
      }
    }
    .ant-input-group-addon {
      width: 4px;
      position: absolute;
      right: 63px;
      top: 0;
      border-radius: 20px;
      z-index: 2;
      background: none;
      .search-btn{
        border-left: 0;
        height: 35px;
        border-color: rgba(0, 0, 0, 0);
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
        background: none;
        &::after{
          content: none;
        }
        span{
          display: flex;
          font-size: 14px;
          color: #333333;
          position: relative;
          align-items: center;
          &::before{
            left: -8px;
            content: '';
            width: 1px;
            height: 15px;
            background: #E9E9E9;
            position: absolute;
          }
        }
      }
    }
    // border: 1px solid #D8DCE0;
  }
  /deep/ .ant-select-selection {
    border-radius: 20px;
    width: 137px;
    height: 35px;
    margin-left: 22px;
    .ant-select-selection__rendered {
      line-height: 35px !important;
    }
  }
}
.flexEnd{
  justify-content: flex-end;
  padding-top: 20px;
}
.between{
  justify-content: space-between;
}
.resourceType{
  display: flex;
  margin-top: 20px;
  align-items: flex-start;
  .label{
    font-size: 14px;
    font-weight: 400;
    color: #596777;
    line-height: 17px;
  }
  .list span{
    color: #000;
    display: flex;
    font-size: 14px;
    cursor: pointer;
    line-height: 1em;
    padding: 2px 10px 7px;
  }
}
.treeSelect{
  margin-right: 22px;
}
.auth{
  display: flex;
  font-weight: 500;
  color: #000000;
  line-height: 20px;
  align-items: center;
  /deep/.ant-switch{
    width: 58px;
    height: 28px;
    background: #E0E6EA;
    &::after{
      width: 24px;
      height: 24px;
    }
  }
  /deep/.ant-switch.ant-switch-checked{
    background: #FF6D00;
  }
  .label{
    font-size: 14px;
    font-weight: 550;
    color: #000000;
    line-height: 20px;
  }
}
.selected{
  font-weight: 550;
  color: #FF6D00 !important;
  position: relative;
  justify-content: center;
  // &::after{
  //   bottom: -4px;
  //   content: '';
  //   width: 23px;
  //   height: 4px;
  //   background: #FF6D00;
  //   border-radius: 3px;
  //   position: absolute;
  // }
}
/deep/ .ant-input-group:focus{
  border: 1px solid #3180ce;
}
</style>
